// A brand new priced line, as it is born everywhere in the quote. The VAT, the
// currency and its symbol come from the quote state: a line laid down without
// them ends up at zero per cent and without a currency.
export const makeLine = (state, costCategory = "materials") => ({
  type:                "service",
  description:         "",
  cost_category:       costCategory,
  quantity:            1,
  // Labour is counted in hours.
  unit:                costCategory === "labor" ? "h" : "",
  unit_price:          0,
  purchase_price:      null,
  discount:            0,
  coefficient:         1,
  ref_product_distrib: "",
  vat_rate:            state.site?.vat_rate || {},
  currency:            state.currency || {},
  currency_symbol:     state.currencySymbol || "€",
})
